// @ngInject
function OrdersApiService($q, $window, $cookies, DS, DSHttpAdapter, ResourcesService) {

    var endpoint = 'orders';

    return {
        approveOrder: approveOrder,
        createMultipleInternalOrders: ResourcesService.apiFactory.create(endpoint + '/multipleinternal', 'InternalOrder'),
        createPurchaseOrder: createPurchaseOrder,
        createWholeOrder: createWholeOrder,
        deleteOrder: ResourcesService.apiFactory.delete(endpoint, 'Order'),
        deleteOrders: deleteOrders,
        deliverOrder: deliverOrder,
        deliverOrderWithDate: deliverOrderWithDate,
        deliverPartially: deliverPartially,
        downloadAsPdf: downloadAsPdf,
        downloadAsCsv: downloadAsCsv,
        downloadDeliveryDocument: downloadDeliveryDocument,
        downloadLabels: downloadLabels,
        downloadLabelsForDate: downloadLabelsForDate,
        downloadPickingList: downloadPickingList,
        downloadTransitReport: downloadTransitReport,
        getAll: getAll,
        getArticleCollections: ResourcesService.apiFactory.get(endpoint + '/articlecollections'),
        getById: getById,
        getByOrderNumber: ResourcesService.apiFactory.get(endpoint + '/ordernumber/'),
        getCompanies: ResourcesService.apiFactory.get(endpoint + '/companies'),
        getCurrencies: ResourcesService.apiFactory.get(endpoint + '/currencies/'),
        getCurrencyDefault: ResourcesService.apiFactory.get(endpoint + '/currencies/default'),
        getDeliveryTerms: ResourcesService.apiFactory.get(endpoint + '/deliveryterms/'),
        getDeliveryDates: getDeliveryDates,
        getWholeDeliveryDates: getWholeDeliveryDates,
        getLocations: ResourcesService.apiFactory.get(endpoint + '/locations'),
        getLocationsDependingOnUser: ResourcesService.apiFactory.get(endpoint + '/userlocations'),
        getMultipleOrderPdf: getMultipleOrderPdf,
        getMultipleOrderCsv: getMultipleOrderCsv,
        getMultipleOrderPickingListPdf: getMultipleOrderPickingListPdf,
        getOrderArticlesForBarcodes: getOrderArticlesForBarcodes,
        getOrderCollections: ResourcesService.apiFactory.get(endpoint + '/ordercollections'),
        getOrderCollectionById: ResourcesService.apiFactory.get(endpoint + '/ordercollection'),
        getOrderTypes: ResourcesService.apiFactory.get('/types/order'),
        getPacksForArticle: ResourcesService.apiFactory.get(endpoint + '/packsforarticle'),
        getPurchaseOrder: ResourcesService.apiFactory.get(endpoint + '/purchaseorders'),
        getPurchaseOrders: getPurchaseOrders,
        getResellerPriceList: ResourcesService.apiFactory.get(endpoint + '/resellerpricelist'),
        getStockForArticle: getStockForArticle,
        getStores: ResourcesService.apiFactory.get(endpoint + '/stores'),
        getUsers: ResourcesService.apiFactory.get(endpoint + '/users/'),
        markAsUndelivered: markAsUndelivered,
        markAsDelivered: markAsDelivered,
        updatePurchaseOrder: updatePurchaseOrder,
        updateOrderNote: updateOrderNote,
        updateWholeOrder: updateWholeOrder,
        getStocksForArticleVariants: getStocksForArticleVariants,
        getOrderDeliveryPlan: getOrderDeliveryPlan,
        saveOrderDeliveryPlan: saveOrderDeliveryPlan,
        getDeliveryPlanningTemplate: getDeliveryPlanningTemplate,
        saveMainComment: saveMainComment,
        isDeliveryPlanningEnabled: ResourcesService.apiFactory.get(endpoint + '/isdeliveryplanningenabled'),
        isAllowedToForceChangeApproveOrderEnabled: ResourcesService.apiFactory.get(endpoint + '/isforceapproveorderenabled'),
    };

    function saveMainComment(mainCommentData) {
        var deferred = $q.defer();
       
        var sendMainCommentData = angular.copy(mainCommentData);

        var jsonData = JSON.stringify(sendMainCommentData);
      

        DSHttpAdapter.PUT(DS.defaults.basePath + 'orders/savemaincomment',jsonData).then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getDeliveryPlanningTemplate(templateId, orderPlannedDate, deliveryTermsId){
        var deferred = $q.defer();

        var params = {}
        params.orderPlannedDeliveryDate = orderPlannedDate;
        params.templateId = templateId;
        params.deliveryTermsId = deliveryTermsId;

        DSHttpAdapter.GET(DS.defaults.basePath + 'orders/getdeliveryplanningtemplate', {params : params}).then(function(response){
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function saveOrderDeliveryPlan(plan, orderId, doRecalculate){
        var deferred = $q.defer();

        var planData = {
            id : plan.id,
            confirmedDate : plan.confirmedDate,
            predictedDate : plan.predictedDate,
            user : plan.user,
            comment : plan.comment,
            recalculate : doRecalculate
        };

        var sendPlanData = angular.copy(planData);

        var confirmedDate = sendPlanData.confirmedDate;
        var predictedDate = sendPlanData.predictedDate;
        
        if(confirmedDate !== null){
            confirmedDate = new Date(confirmedDate);
            sendPlanData.confirmedDate = new Date(Date.UTC(confirmedDate.getFullYear(), confirmedDate.getMonth(), confirmedDate.getDate()));
        }
        predictedDate = new Date(predictedDate);
        sendPlanData.predictedDate = new Date(Date.UTC(predictedDate.getFullYear(), predictedDate.getMonth(), predictedDate.getDate()));

        var jsonData = JSON.stringify(sendPlanData);

        DSHttpAdapter.PUT(DS.defaults.basePath + 'orders/' + orderId + '/savedeliveryplanning', jsonData).then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getOrderDeliveryPlan(orderId){
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'orders/deliveryplanning/' + orderId).then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise; 
    }

    function getStockForArticle(articleId, locationId) {
        var deferred = $q.defer();
        var params = {
            articleId: articleId,
            locationId: locationId
        };

        DSHttpAdapter.GET(DS.defaults.basePath + 'orders/article/' + articleId + '/location/' + locationId + '/stock', { params: params }).then(function getAllOrders(response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function createPurchaseOrder(purchaseOrder) {
        var deferred = $q.defer();

        console.log("Sending the following purchase order data:");
        console.log(purchaseOrder);

        var jsonRequest = JSON.stringify(purchaseOrder);

        DSHttpAdapter.POST(DS.defaults.basePath + 'orders/purchaseorder', jsonRequest).then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function createWholeOrder(order, barcodesList, modifiedDeliveryPlanningTemplate) {
        var deferred = $q.defer();

        // To prevent the Json stringification from do any timezone conversion.
        var sendOrderData = angular.copy(order);
        var date = sendOrderData.plannedDeliveryDate;
        date = new Date(date);
        sendOrderData.plannedDeliveryDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));

        if((modifiedDeliveryPlanningTemplate !== undefined && modifiedDeliveryPlanningTemplate.stages !== undefined) ? modifiedDeliveryPlanningTemplate.stages.length : 0 > 0){
            _.forEach(modifiedDeliveryPlanningTemplate.stages, function(stage){
                var newStageDate = stage.plannedDate;
                newStageDate = new Date(newStageDate);
                stage.plannedDate = new Date(Date.UTC(newStageDate.getFullYear() ,newStageDate.getMonth() ,newStageDate.getDate()));
            })
        }

        var requestObject = {
            order: sendOrderData,
            barcodes: (barcodesList !== undefined) ? barcodesList : [],
            deliveryPlanningStages: (modifiedDeliveryPlanningTemplate !== undefined) ? modifiedDeliveryPlanningTemplate.stages : null
        };

        var jsonRequest = JSON.stringify(requestObject);

        DSHttpAdapter.POST(DS.defaults.basePath + 'orders/completeorder', jsonRequest).then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function deleteOrders(orderIds) {
        var deferred = $q.defer();

        console.log("OrderIds are:");
        console.log(orderIds);

        var request = {
            orderIds: orderIds
        };

        var params = {
            orderIds: orderIds
        };

        DSHttpAdapter.DEL(DS.defaults.basePath + 'orders/', {params: params}).then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function deliverOrder(orderId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'orders/' + orderId + '/deliver').then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getDeliveryDates(orderId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'orders/' + orderId + '/deliverydates').then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }
    function getWholeDeliveryDates(orderId, timeProximity, timeType) {
        var deferred = $q.defer();
        
        var params = {};

        if(timeProximity && timeProximity >= 0){
            params.timeProximity = timeProximity;
        }

        if(timeType && timeType >= 0){
            params.timeType = timeType;
        }

        DSHttpAdapter.GET(DS.defaults.basePath + 'orders/' + orderId + '/deliverydates/whole', {params: params}).then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function deliverOrderWithDate(orderId, date) {
        var deferred = $q.defer();

        var delivery = { deliveryDate: date };

        DSHttpAdapter.POST(DS.defaults.basePath + 'orders/' + orderId + '/deliver', delivery).then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.resolve(handleError);
        });

        return deferred.promise;
    }

    function deliverPartially(order) {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + 'orders/' + order.id + '/deliverpartially', order).then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function downloadAsPdf(id) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'orders/' + id + '/aspdf', { responseType: 'arraybuffer' }).then(function(response) {
            var blob = new Blob([response.data], {type: 'application/pdf'});
            var contentDisposition = response.headers('Content-Disposition');
            var fileName = getFileName(contentDisposition, 'order.pdf');

            if ($window.navigator.msSaveBlob) {
                $window.navigator.msSaveBlob(blob, fileName);
            } else {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                var url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);

                a.parentNode.removeChild(a);
            }

            deferred.resolve(response);
        },function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function downloadAsCsv(id) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'orders/' + id + '/ascsv', { responseType: 'arraybuffer' }).then(function(response) {
            var blob = new Blob([response.data], {type: 'text/csv'});
            var contentDisposition = response.headers('Content-Disposition');
            var fileName = getFileName(contentDisposition, 'order.csv');

            if ($window.navigator.msSaveBlob) {
                $window.navigator.msSaveBlob(blob, fileName);
            } else {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                var url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);

                a.parentNode.removeChild(a);
            }

            deferred.resolve(response);
        },function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getMultipleOrderPdf(ids) {
        var deferred = $q.defer();

        var request = {
            orderIds: ids
        };

        DSHttpAdapter.POST(DS.defaults.basePath + 'orders/aspdf', request, { responseType: 'arraybuffer' }).then(function(response) {
            var blob = new Blob([response.data], {type: 'application/pdf'});
            var contentDisposition = response.headers('Content-Disposition');
            var fileName = getFileName(contentDisposition, 'order.pdf');

            if ($window.navigator.msSaveBlob) {
                $window.navigator.msSaveBlob(blob, fileName);
            } else {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                var url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);

                a.parentNode.removeChild(a);
            }

            deferred.resolve(response);
        },function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getMultipleOrderCsv(ids){
        var deferred = $q.defer();

        var request = {
            orderIds: ids
        };

        DSHttpAdapter.POST(DS.defaults.basePath + 'orders/ascsv', request, { responseType: 'arraybuffer' }).then(function(response) {
            var blob = new Blob([response.data], {type: 'text/csv'});
            var contentDisposition = response.headers('Content-Disposition');
            var fileName = getFileName(contentDisposition, 'order.csv');

            if ($window.navigator.msSaveBlob) {
                $window.navigator.msSaveBlob(blob, fileName);
            } else {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                var url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);

                a.parentNode.removeChild(a);
            }

            deferred.resolve(response);
        },function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getMultipleOrderPickingListPdf(incomingRequest) {
        var deferred = $q.defer();

        var request = {
            orderIds: incomingRequest.orderIds,
            includeStorageLocation: incomingRequest.includeStorageLocation,
            includeIsPhotographed: incomingRequest.includeIsPhotographed,
            locale: incomingRequest.languageCode,
            grouping: incomingRequest.grouping
        };

        DSHttpAdapter.POST(DS.defaults.basePath + 'orders/pickinglist/aspdf', request, { responseType: 'arraybuffer' }).then(function(response) {
            var blob = new Blob([response.data], {type: 'application/pdf'});
            var contentDisposition = response.headers('Content-Disposition');
            var fileName = getFileName(contentDisposition, 'pickinglist.pdf');

            if ($window.navigator.msSaveBlob) {
                $window.navigator.msSaveBlob(blob, fileName);
            } else {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                var url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);

                a.parentNode.removeChild(a);
            }

            deferred.resolve(response);
        },function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function downloadDeliveryDocument(id, startDate, endDate, useOriginalPrice) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'orders/' + id + '/delivery/aspdf' + '?startDate=' + startDate + '&endDate=' + endDate + '&useOriginalPrice=' + useOriginalPrice, { responseType: 'arraybuffer' }).then(function(response) {
            var blob = new Blob([response.data], {type: 'application/pdf'});
            var contentDisposition = response.headers('Content-Disposition');
            var fileName = getFileName(contentDisposition, startDate !== undefined ? 'orderdelivery_' + startDate + '.pdf' : 'orderdelivery.pdf');

            if ($window.navigator.msSaveBlob) {
                $window.navigator.msSaveBlob(blob, fileName);
            } else {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                var url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);

                a.parentNode.removeChild(a);
            }

            deferred.resolve(response);
        },function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function downloadTransitReport(reportParameters) {
        var url = $window.URL || $window.webkitURL;

        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + endpoint + '/transitReport', reportParameters, { responseType: 'arraybuffer' }).then(function (response) {
            //If 204 the call returned no result/empty list don't return a downloadable file
            if (response && response.status === 204) {
                deferred.resolve(response);
                return deferred.promise;
            }

            //"attachment; filename=stockpickinglist20190110.pdf"
            var blob = new Blob([response.data], { type: 'text/csv' });
            var contentDisposition = response.headers('Content-Disposition');
            var fileName = getFileName(contentDisposition, 'TransitReport.csv');

            if ($window.navigator.msSaveBlob) {
                $window.navigator.msSaveBlob(blob, fileName);
            } else {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                var downloadUrl = url.createObjectURL(blob);
                a.href = downloadUrl;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);

                a.parentNode.removeChild(a);
            }

            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function downloadPickingList(incomingRequest) {
        var deferred = $q.defer();

        var request = {
            orderId: incomingRequest.orderId,
            includeStorageLocation: incomingRequest.includeStorageLocation,
            includeIsPhotographed: incomingRequest.includeIsPhotographed,
            includePrices : incomingRequest.includePrices,
            locale: incomingRequest.languageCode,
            grouping: incomingRequest.grouping
        };

        DSHttpAdapter.POST(DS.defaults.basePath + 'orders/' + incomingRequest.orderId + '/pickinglist/aspdf', request, { responseType: 'arraybuffer' }).then(function(response) {
            var blob = new Blob([response.data], { type: 'application/pdf' });
            var contentDisposition = response.headers('Content-Disposition');
            var fileName = getFileName(contentDisposition, 'pickinglist.pdf');

            if ($window.navigator.msSaveBlob) {
                $window.navigator.msSaveBlob(blob, fileName);
            } else {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                var url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);

                a.parentNode.removeChild(a);
            }

            deferred.resolve(response);
        },function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getFileName(contentDisposition, defaultValue) {
        //"attachment; filename=PickingList36012-36013.pdf"
        var filename = defaultValue;
        if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
            var filenameRegex = /(?![=]{1})([\w\d\s-_]){1,}.(pdf|csv|xls|xlsx)/ig;
            var matches = new RegExp(filenameRegex).exec(contentDisposition);
            if (matches != null && matches[0]) {
                filename = matches[0];
            }
        }
        return filename;
    }

    function downloadLabels(orderId, orderNumber) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'orders/' + orderId + '/labels', { responseType: 'arraybuffer' }).then(function(response) {
            var blob = new Blob([response.data], {type: 'application/pdf'});
            var contentDisposition = response.headers('Content-Disposition');
            var fileName = getFileName(contentDisposition, orderNumber !== undefined ? 'label_' + orderNumber + '.pdf' : 'label.pdf');

            if ($window.navigator.msSaveBlob) {
                $window.navigator.msSaveBlob(blob, fileName);
            } else {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                var url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);

                a.parentNode.removeChild(a);
            }

            deferred.resolve(response);
        },function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function downloadLabelsForDate(request) {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + 'orders/labels', request, { responseType: 'arraybuffer' }).then(function(response) {
            var blob = new Blob([response.data], {type: 'application/pdf'});
            var contentDisposition = response.headers('Content-Disposition');
            var fileName = getFileName(contentDisposition, request.orderNumber !== undefined ? 'label_' + request.orderNumber + '.pdf' : 'label.pdf');

            if ($window.navigator.msSaveBlob) {
                $window.navigator.msSaveBlob(blob, fileName);
            } else {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                var url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);

                a.parentNode.removeChild(a);
            }

            deferred.resolve(response);
        },function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getAll(searchTerms) {
        var deferred = $q.defer();
        var params = {};

        if (searchTerms.page && searchTerms.page < 0) {
            searchTerms.page = 1;
        }

        if (searchTerms.limit && searchTerms.limit > 0) {
            params.limit = searchTerms.limit;
        }

        if (!_.isEmpty(searchTerms.searchTerm)) {
            params.searchTerm = searchTerms.searchTerm;
        }

        params.page = searchTerms.page;
        params.orderTypes = searchTerms.orderTypes;
        params.onlyUndelivered = searchTerms.showUndeliveredOnly;
        params.onlyUnprinted = searchTerms.showUnprintedOnly;
        params.onlyUnapproved = searchTerms.showUnapprovedOnly;
        params.onlyOrderNumber = searchTerms.onlyOrderNumber;
        params.monthBack = searchTerms.monthBack;

        DSHttpAdapter.GET(DS.defaults.basePath + 'orders', { params: params }).then(function getAllOrders(response) {
            deferred.resolve(response.data.data);
        }, function getAllOrdersError(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getById(id) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'orders/' + id + "/new").then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getPurchaseOrders(page, filter, pageSize, wantedTypes, onlyUndelivered) {
        var deferred = $q.defer();
        var params = {};

        if (page && page > 1) {
            params.page = page - 1;
        }

        if (pageSize && pageSize > 0) {
            params.pageSize = pageSize;
        }

        if (!_.isEmpty(filter)) {
            params.searchTerm = filter;
        }

        params.orderTypes = wantedTypes;
        params.onlyUndelivered = onlyUndelivered;

        DSHttpAdapter.GET(DS.defaults.basePath + 'orders/purchaseorders', {params: params}).then(function getAllOrders(response) {
            deferred.resolve(response);
        }, function getAllOrdersError(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function markAsUndelivered(orderId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'orders/' + orderId + "/markasundelivered").then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function updateOrderNote(orderId, note, externalOrderReference) {
        var deferred = $q.defer();

        var request = {
            note: note,
            externalOrderReference: externalOrderReference
        };

        var jsonData = JSON.stringify(request);

        DSHttpAdapter.PUT(DS.defaults.basePath + 'orders/' + orderId + "/notes", jsonData).then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }
    function markAsDelivered(orderId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'orders/' + orderId + "/markasdelivered").then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }
   
    function approveOrder(orderId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'orders/' + orderId + "/approve").then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function updatePurchaseOrder(purchaseOrder) {
        var deferred = $q.defer();

        var jsonData = JSON.stringify(purchaseOrder);

        DSHttpAdapter.PUT(DS.defaults.basePath + 'orders/purchaseorder/', jsonData).then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function updateWholeOrder(orderData) {
        var deferred = $q.defer();

        // To prevent the Json stringification from do any timezone conversion.
        var sendOrderData = angular.copy(orderData);
        var date = sendOrderData.plannedDeliveryDate;

        date = new Date(date);

        sendOrderData.plannedDeliveryDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));

        var jsonorder = JSON.stringify(sendOrderData);

        DSHttpAdapter.PUT(DS.defaults.basePath + 'orders/', jsonorder).then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getStocksForArticleVariants(articleVariantIds, locationIds) {
        var deferred = $q.defer();

        var request = {
            articleVariantIds: articleVariantIds,
            locationIds: locationIds
        };

        DSHttpAdapter.POST(DS.defaults.basePath + 'orders/stock', request).then(function(response) {
            deferred.resolve(response);
        },  function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getOrderArticlesForBarcodes(barcodes, companyId, currencyId, currencyRate) {
        var deferred = $q.defer();

        var request = {
            barcodes: barcodes,
            companyId: companyId,
            currencyId: currencyId,
            currencyRate: currencyRate
        };

        DSHttpAdapter.POST(DS.defaults.basePath + 'orders/getorderarticlesforbarcodes', request).then(function(response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function handleError(error) {
        return ResourcesService.handleResourceError(error);
    }
}

angular
    .module('orders.api', [])
    .factory('OrdersApiService', OrdersApiService);
